import { render } from "./JobRunsList.vue?vue&type=template&id=dfcb7616&scoped=true&ts=true"
import script from "./JobRunsList.vue?vue&type=script&lang=ts"
export * from "./JobRunsList.vue?vue&type=script&lang=ts"

import "./JobRunsList.vue?vue&type=style&index=0&id=dfcb7616&lang=scss&scoped=true"
import "./JobRunsList.vue?vue&type=style&index=1&id=dfcb7616&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfcb7616"]])

export default __exports__